import en from './files/en.json';
import de from './files/de.json';
import it from './files/it.json';
import es from './files/es.json';
import nl from './files/nl.json';
import hr from './files/hr.json';
import fr from './files/fr.json';

export default {
    en: en,
    de: de,
    it: it,
    es: es,
    nl: nl,
    hr: hr,
    fr: fr
};



// WEBPACK FOOTER //
// ./src/i18n/messages.js